import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { DateInterval } from '../../../../_shared/enums';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-metric-block',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './metric-block.component.html',
  styleUrl: './metric-block.component.scss'
})
export class MetricBlockComponent {
  @Input() title: string;
  @Input() value: number | string;
  @Input() difference: number;
  @Input() percentageDifference: number;
  @Input() isLoading: boolean;
  @Input() dateInterval: DateInterval;

  private readonly transloco = inject(TranslocoService);

  /** Values are translation keys, resolved by the `interval` getter. */
  intervalMap: { [key in DateInterval]: string } = {
    [DateInterval.Day]: 'overtimeManagement.intervals.yesterday',
    [DateInterval.Week]: 'overtimeManagement.intervals.lastWeek',
    [DateInterval.Month]: 'overtimeManagement.intervals.lastMonth',
    [DateInterval.Half]: 'overtimeManagement.intervals.last15Days',
    [DateInterval.Last3Hours]: 'overtimeManagement.intervals.previous3Hours',
    [DateInterval.Last6Hours]: 'overtimeManagement.intervals.previous6Hours',
    [DateInterval.Last12Hours]: 'overtimeManagement.intervals.previous12Hours',
    [DateInterval.Today]: 'overtimeManagement.intervals.yesterday',
    [DateInterval.Yesterday]: 'overtimeManagement.intervals.previousDay'
  }

  getClass(value: number): string {
    if (value < 0) return 'text-success';
    if (value > 0) return 'text-attention';
    return 'text-secondary';
  }

  get interval(): string {
    // dateInterval is optional, so an unset value must not reach translate().
    const key = this.intervalMap[this.dateInterval];
    return key ? this.transloco.translate(key) : '';
  }
}
